"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmPhoneView = ConfirmPhoneView;
var React = _interopRequireWildcard(require("react"));
var _ViewContainer = require("../ViewContainer");
var _TitleContainer = require("../TitleContainer");
var _InfoContainer = require("./containers/InfoContainer");
var _FormContainer = require("./containers/FormContainer");
var _tracking = require("../../utils/tracking");
var _HelpContainer = require("../HelpContainer");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ConfirmPhoneView(_ref) {
  let {
    source
  } = _ref;
  React.useEffect(() => {
    (0, _tracking.trackConfirmPhoneShown)(source);
  }, []);
  const handleHelpClick = React.useCallback(() => (0, _tracking.trackLoginNeedHelp)(source), [source]);
  return /*#__PURE__*/React.createElement(_ViewContainer.ViewContainer, null, /*#__PURE__*/React.createElement(_TitleContainer.TitleContainer, null), /*#__PURE__*/React.createElement(_InfoContainer.InfoContainer, null), /*#__PURE__*/React.createElement(_FormContainer.FormContainer, null), /*#__PURE__*/React.createElement(_HelpContainer.HelpContainer, {
    onClick: handleHelpClick
  }));
}